import React, { useState } from "react";
import { FaHeart, FaEye, FaStar, FaTimes } from "react-icons/fa";
import { useCart } from "../context/CartContext";

const ProductCard = ({ product }) => {
  const { addToCart, toggleWishlist, isInWishlist } = useCart();

  const liked = isInWishlist(product.id);

  const [added, setAdded] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  /* ================= ADD TO CART ================= */
  const handleAddToCart = (e) => {
    e.stopPropagation();

    addToCart(product);

    setAdded(true);

    setTimeout(() => {
      setAdded(false);
    }, 1200);
  };

  /* ================= WISHLIST ================= */
  const handleWishlist = (e) => {
    e.stopPropagation();
    toggleWishlist(product);
  };

  return (
    <>
      <div
        className="group relative rounded-2xl overflow-hidden
        bg-[#fdf8f5]
        border border-[#e7b6a1]/20
        shadow-sm
        hover:shadow-xl
        hover:-translate-y-2
        transition duration-300"
      >
        {/* IMAGE */}
        <div
          className="relative overflow-hidden cursor-pointer"
          onClick={() => setShowPreview(true)}
        >
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="w-full h-72 object-cover
            group-hover:scale-110
            transition duration-500"
          />

          {/* Overlay */}
          <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition"></div>

          {/* Badge */}
          {product.tag && (
            <span
              className={`absolute top-3 left-3 text-[10px] px-3 py-1 rounded-full font-medium
              ${
                product.tag === "SALE"
                  ? "bg-pink-200 text-pink-800"
                  : product.tag === "BESTSELLER"
                  ? "bg-yellow-200 text-yellow-800"
                  : "bg-black text-white"
              }`}
            >
              {product.tag}
            </span>
          )}

          {/* Wishlist */}
          <button
            onClick={handleWishlist}
            className={`absolute top-3 right-3 p-2 rounded-full backdrop-blur shadow transition
            ${
              liked
                ? "bg-red-500 text-white"
                : "bg-white/80 hover:bg-[#e7b6a1] hover:text-white"
            }`}
          >
            <FaHeart size={14} />
          </button>

          {/* Eye */}
          <div className="absolute inset-0 flex justify-center items-center opacity-0 group-hover:opacity-100 transition">
            <button
              onClick={(e) => {
                e.stopPropagation();
                setShowPreview(true);
              }}
              className="bg-white p-3 rounded-full shadow hover:bg-[#e7b6a1] hover:text-white transition"
            >
              <FaEye />
            </button>
          </div>

          {/* Add Cart */}
          <div className="absolute bottom-4 left-0 right-0 flex justify-center opacity-0 group-hover:opacity-100 transition">
            <button
              onClick={handleAddToCart}
              className={`px-6 py-2 rounded-full text-sm transition
              ${
                added
                  ? "bg-green-500 text-white"
                  : "bg-black text-white hover:bg-[#e7b6a1]"
              }`}
            >
              {added ? "Added ✓" : "ADD TO CART"}
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-5">
          <p className="text-xs uppercase tracking-wide text-gray-400 mb-1">
            {product.category}
          </p>

          <h3 className="font-semibold text-lg font-serif">
            {product.name}
          </h3>

          <div className="flex items-center gap-1 text-yellow-400 mt-2">
            {[...Array(product.rating || 5)].map((_, i) => (
              <FaStar key={i} />
            ))}

            <span className="text-gray-400 text-xs ml-1">
              ({product.reviews})
            </span>
          </div>

          <div className="flex items-center gap-2 mt-2">
            <span className="font-semibold text-lg">
              ₹{product.price}
            </span>

            {product.oldPrice && (
              <span className="line-through text-gray-400 text-sm">
                ₹{product.oldPrice}
              </span>
            )}
          </div>
        </div>
      </div>

      {/* ================= IMAGE PREVIEW ================= */}

      {showPreview && (
        <div
          className="fixed inset-0 bg-black/90 z-[99999]
          flex justify-center items-center p-6"
          onClick={() => setShowPreview(false)}
        >
          <button
            onClick={() => setShowPreview(false)}
            className="absolute top-6 right-6 text-white text-3xl"
          >
            <FaTimes />
          </button>

          <img
            src={product.image}
            alt={product.name}
            className="max-w-[95vw] max-h-[90vh] rounded-xl shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
};

export default ProductCard;